/* eslint-disable @typescript-eslint/naming-convention */
const UTM_STORAGE_KEY__CMD = 'CMD__UTM_PARAMS';
const UTM_STORAGE_KEY__VMD = 'VMD__UTM_PARAMS';

export { UTM_STORAGE_KEY__CMD, UTM_STORAGE_KEY__VMD };
